module.exports = __webpack_public_path__ + "img/software_pclaw.2b35b2a9.jpg";